var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { id: "Group 13" } }, [
        _c(
          "g",
          {
            attrs: {
              id: "customer-service-agent 2",
              "clip-path": "url(#clip0)",
            },
          },
          [
            _c("g", { attrs: { id: "Page 1" } }, [
              _c("g", { attrs: { id: "017   Customer Support" } }, [
                _c("path", {
                  attrs: {
                    id: "Shape",
                    d: "M10.4579 8.82618C10.2957 7.79082 9.82462 6.82857 9.10632 6.06547C8.11189 5.00056 6.72018 4.396 5.26316 4.396C3.80613 4.396 2.41442 5.00056 1.42 6.06547C0.701698 6.82857 0.230605 7.79082 0.0684211 8.82618C0.0238457 8.91882 0.000472351 9.02022 0 9.12302V10.5265C0 10.9141 0.314186 11.2283 0.701754 11.2283H1.29825C0.970773 10.3213 0.970773 9.32829 1.29825 8.42127H0.877193C1.07332 7.71993 1.43587 7.07632 1.93404 6.54512C2.79578 5.62193 4.00202 5.09779 5.26491 5.09779C6.5278 5.09779 7.73405 5.62193 8.59579 6.54512C9.09332 7.0765 9.45526 7.7201 9.65088 8.42127H9.22807C9.55554 9.32829 9.55554 10.3213 9.22807 11.2283H9.82456C10.2121 11.2283 10.5263 10.9141 10.5263 10.5265V9.12302C10.5258 9.02022 10.5025 8.91882 10.4579 8.82618Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    id: "Shape_2",
                    d: "M1.75452 9.82448C1.75405 8.44507 2.56186 7.19336 3.81899 6.62555C5.07612 6.05775 6.54931 6.27922 7.58394 7.19154C8.61857 8.10386 9.02265 9.53776 8.61663 10.8561C7.96329 11.069 7.2828 11.1872 6.59592 11.2069C6.4416 10.7983 6.05095 10.5275 5.61417 10.5262H4.91242C4.33106 10.5262 3.85978 10.9975 3.85978 11.5789C3.85978 12.1602 4.33106 12.6315 4.91242 12.6315H5.61417C6.06638 12.6301 6.46689 12.3393 6.60821 11.9097C7.15224 11.888 7.69323 11.8175 8.2247 11.6992C7.39148 13.0205 5.78456 13.6309 4.28425 13.1962C2.78394 12.7615 1.75232 11.3865 1.75452 9.82448Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    id: "Shape_3",
                    d: "M5.96488 11.5789C5.96488 11.7727 5.80779 11.9298 5.614 11.9298H4.91225C4.71846 11.9298 4.56137 11.7727 4.56137 11.5789C4.56137 11.3851 4.71846 11.228 4.91225 11.228H5.614C5.80779 11.228 5.96488 11.3851 5.96488 11.5789Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    id: "Shape_4",
                    d: "M8.73466 14.4239C9.6603 15.3413 10.1793 16.5916 10.1754 17.8948V19.6492C10.1754 19.843 10.0183 20.0001 9.82448 20.0001H8.0701V17.8948C8.0701 17.701 7.913 17.5439 7.71922 17.5439C7.52544 17.5439 7.36834 17.701 7.36834 17.8948V20.0001H3.15782V17.8948C3.15782 17.701 3.00072 17.5439 2.80694 17.5439C2.61316 17.5439 2.45606 17.701 2.45606 17.8948V20.0001H0.701677C0.507893 20.0001 0.3508 19.843 0.3508 19.6492V17.8948C0.352415 16.0008 1.4428 14.2764 3.15326 13.4629C4.45597 14.2254 6.06878 14.2254 7.3715 13.4629C7.87845 13.7013 8.33979 14.0266 8.73466 14.4239Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    id: "Oval",
                    d: "M12.9827 3.50864C13.1765 3.50864 13.3336 3.35155 13.3336 3.15776C13.3336 2.96398 13.1765 2.80688 12.9827 2.80688C12.7889 2.80688 12.6318 2.96398 12.6318 3.15776C12.6318 3.35155 12.7889 3.50864 12.9827 3.50864Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    id: "Oval_2",
                    d: "M17.8945 3.50864C18.0882 3.50864 18.2453 3.35155 18.2453 3.15776C18.2453 2.96398 18.0882 2.80688 17.8945 2.80688C17.7007 2.80688 17.5436 2.96398 17.5436 3.15776C17.5436 3.35155 17.7007 3.50864 17.8945 3.50864Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    id: "Oval_3",
                    d: "M15.4387 3.50864C15.6325 3.50864 15.7896 3.35155 15.7896 3.15776C15.7896 2.96398 15.6325 2.80688 15.4387 2.80688C15.2449 2.80688 15.0878 2.96398 15.0878 3.15776C15.0878 3.35155 15.2449 3.50864 15.4387 3.50864Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    id: "Shape_5",
                    d: "M18.9475 0H11.9299C11.3486 0 10.8773 0.471279 10.8773 1.05263V5.26316C10.8773 5.84451 11.3486 6.31579 11.9299 6.31579H12.544L12.2808 8.42105L14.6878 6.31579H18.9475C19.5288 6.31579 20.0001 5.84451 20.0001 5.26316V1.05263C20.0001 0.471279 19.5288 0 18.9475 0ZM12.9826 4.21053C12.4012 4.21053 11.9299 3.73925 11.9299 3.15789C11.9299 2.57654 12.4012 2.10526 12.9826 2.10526C13.5639 2.10526 14.0352 2.57654 14.0352 3.15789C14.0352 3.43707 13.9243 3.70481 13.7269 3.90222C13.5295 4.09962 13.2617 4.21053 12.9826 4.21053ZM15.4387 4.21053C14.8573 4.21053 14.3861 3.73925 14.3861 3.15789C14.3861 2.57654 14.8573 2.10526 15.4387 2.10526C16.02 2.10526 16.4913 2.57654 16.4913 3.15789C16.4913 3.43707 16.3804 3.70481 16.183 3.90222C15.9856 4.09962 15.7179 4.21053 15.4387 4.21053ZM17.8948 4.21053C17.3135 4.21053 16.8422 3.73925 16.8422 3.15789C16.8422 2.57654 17.3135 2.10526 17.8948 2.10526C18.4762 2.10526 18.9475 2.57654 18.9475 3.15789C18.9475 3.43707 18.8366 3.70481 18.6392 3.90222C18.4417 4.09962 18.174 4.21053 17.8948 4.21053Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    id: "Shape_6",
                    d: "M18.9475 12.2806H15.7405L13.3334 10.1753L13.5966 12.2806H12.9826C12.4012 12.2806 11.9299 12.7518 11.9299 13.3332V16.4911C11.9299 17.0724 12.4012 17.5437 12.9826 17.5437H18.9475C19.5288 17.5437 20.0001 17.0724 20.0001 16.4911V13.3332C20.0001 12.7518 19.5288 12.2806 18.9475 12.2806ZM13.3334 13.6841H14.3861C14.5799 13.6841 14.7369 13.8412 14.7369 14.0349C14.7369 14.2287 14.5799 14.3858 14.3861 14.3858H13.3334C13.1397 14.3858 12.9826 14.2287 12.9826 14.0349C12.9826 13.8412 13.1397 13.6841 13.3334 13.6841ZM16.1405 16.1402H13.3334C13.1397 16.1402 12.9826 15.9831 12.9826 15.7893C12.9826 15.5955 13.1397 15.4384 13.3334 15.4384H16.1405C16.3342 15.4384 16.4913 15.5955 16.4913 15.7893C16.4913 15.9831 16.3342 16.1402 16.1405 16.1402ZM18.5966 16.1402H17.544C17.3502 16.1402 17.1931 15.9831 17.1931 15.7893C17.1931 15.5955 17.3502 15.4384 17.544 15.4384H18.5966C18.7904 15.4384 18.9475 15.5955 18.9475 15.7893C18.9475 15.9831 18.7904 16.1402 18.5966 16.1402ZM18.5966 14.3858H15.7896C15.5958 14.3858 15.4387 14.2287 15.4387 14.0349C15.4387 13.8412 15.5958 13.6841 15.7896 13.6841H18.5966C18.7904 13.6841 18.9475 13.8412 18.9475 14.0349C18.9475 14.2287 18.7904 14.3858 18.5966 14.3858Z",
                    fill: "white",
                  },
                }),
              ]),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0" } }, [
          _c("rect", { attrs: { width: "20", height: "20", fill: "white" } }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }